import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledSearchInput = styled.input `
  border: none;
  outline: none;

  :focus {
    outline: none;
    border: none;
  }

  width: 100%;
  font-size: ${theme.fontSize.large};
  flex: 1;
  background-color: transparent;
  color: ${theme.semantic.foreground.primary};
`;
export const InputContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.sm} ${theme.spacing.xl};
`;
